import { EHRProvider } from '@heidi/schema/ml-scribe';

/**
 * Providers on the markdown sectional editor for every onboarded user, with no
 * flag: neither has a legacy JSON-editor cohort to keep stable. Mirrors the
 * unflagged branches of the backend editor-version resolver.
 */
const UNFLAGGED_MARKDOWN_SECTIONAL_PROVIDERS: ReadonlySet<EHRProvider> = new Set([
  EHRProvider.Telus_CHR_EHR_Launch,
  EHRProvider.eClinicalWorks,
]);

export const isUnflaggedMarkdownSectional = (ehrProvider?: EHRProvider | null): boolean =>
  ehrProvider != null && UNFLAGGED_MARKDOWN_SECTIONAL_PROVIDERS.has(ehrProvider);
